import { css } from '@emotion/css'
import { mediaQueryHelper, lineHeight } from '@offerzen/pinata'

import { breakpoint, fontSize, spacing, fontWeight } from '../../lib/styles'
import colors from '../../lib/themes/colors'

const styles = {
  standardNavigation: css({
    backgroundColor: colors.darkEclipse,
    height: '62px',
    padding: `0 10px 0 ${spacing.large}px`,
    position: 'relative', // on mobile, the nav isn't fixed to allow focus on the sign up form
    width: '100%',
    top: 0,
    zIndex: 10002, // z-index has been set this high to avoid conflict with other components (E.g Cookie Banner whose z-index is set to 9999)
    borderBottom: '1px solid rgba(41, 139, 242, 0.2)',
    transform: 'translateZ(1px)',

    'a:link': {
      textDecoration: 'none',
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      padding: `0 ${spacing.large}px`,
      position: 'fixed',
    },
    [mediaQueryHelper(500, 'max-height')]: {
      position: 'relative',
    },
  }),

  offerzenLogoLink: css({
    position: 'relative',
    marginRight: 'auto',
    display: 'inline-block',
    alignSelf: 'center',
    lineHeight: 0,
  }),

  offerzenLogoImage: css({
    height: 30,
  }),

  navigationBarItems: css({
    display: 'flex',
    flexDirection: 'row',
    maxWidth: '1200px',
    margin: 'auto',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    alignItems: 'center',
    minHeight: '100%',
  }),

  navigationLinksContainer: css({
    display: 'none',

    [mediaQueryHelper(breakpoint.tablet)]: {
      display: 'flex',
    },
  }),

  outlinedNavButton: css({
    display: 'inline-block',
    fontSize: fontSize.small,
    fontWeight: fontWeight.semiBold,
    width: 'auto',
    height: '35px',
    border: `1px solid ${colors.geyser}`,
    backgroundColor: 'transparent',
    borderRadius: 4,
    color: colors.geyser,
    margin: 'auto 15px',
    padding: `${spacing.small}px 15px`,
    alignSelf: 'center',
    whiteSpace: 'nowrap',
    transition: 'border-color .3s ease-out,background-color .3s ease-out',
    flexShrink: 0,
    lineHeight: 1.5,

    '&:hover': {
      borderColor: `${colors.cornflowerBlue} ${colors.mariner} ${colors.mariner} ${colors.cornflowerBlue}`,
      color: colors.white,
      backgroundColor: colors.cornflowerBlue,
    },
  }),

  loginButton: css({
    display: 'inline-block',
    fontSize: fontSize.default,
    lineHeight: '20px',
    justifyContent: 'center',
    color: colors.geyser,
    textAlign: 'center',
    alignSelf: 'stretch',
    fontWeight: fontWeight.regular,
    whiteSpace: 'nowrap',
    transition: 'border-color 0.2s cubic-bezier(0.55, 0.085, 0.68, 0.53), background-color 0.4s ease-out',
    width: 'auto',
    margin: 'auto',
    padding: '21px 15px 20px 15px',
    flexShrink: 0,
    borderBottom: '1px solid transparent',

    '&:hover': {
      borderBottom: `1px solid ${colors.cornflowerBlue}`,
      color: colors.white,
      backgroundImage: 'linear-gradient(180deg, rgba(66,156,245,0),rgba(41,139,242,.3))',

      img: {
        transform: 'translate3d(2px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
        transformStyle: 'preserve-3d',
      },
    },
  }),

  arrowImage: css({
    height: '8px',
    paddingLeft: spacing.small,
    transition: 'transform .4s ease-out',
    transform: 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
    transformStyle: 'preserve-3d',
  }),

  mobileNav: css({
    display: 'flex',
    [mediaQueryHelper(breakpoint.tablet)]: {
      display: 'none',
    },
  }),

  navigationText: css({
    display: 'inline-block',
    padding: '21px 0px 20px 15px',
    width: 'auto',
    whiteSpace: 'nowrap',
    fontWeight: fontWeight.regular,
    fontSize: fontSize.small,
    flex: '0 0 auto',
    flexShrink: 0,
    lineHeight: lineHeight.default,
    textAlign: 'center',
    borderBottom: '1px solid transparent',
    borderLeft: '0px',
    margin: 0,
    color: colors.geyser,
  }),
}

export default styles
